export interface Restaurant {
  _id: string;
  displayName: string;
  isActive: boolean;
}

export interface Price {
  value: number;
  text: string;
}

export enum OrderStatus {
  WAITING_FOR_PAYMENT = "waiting_for_payment",
  PROCESSING = "processing",
  COOKING = "cooking",

  WAITING_FOR_RIDER = "waiting_for_rider",
  WAITING_FOR_PICKUP = "waiting_for_pickup",

  DRIVER_ASSIGNED = "driver_assigned",
  COLLECTED = "collected",

  COMPLETED = "completed",
  CANCELLED = "cancelled",
}

export interface OrderDetails {
  _id: string;
  displayId: string;
  OrderType: OrderType;
  status: OrderStatus;
  paymentInfo: {
    orderPrice: Price;
  };
  createdAt: string;
  cart: CartItem[];
}

export interface CartItem {
  itemId: string;
  title: string;
  quantity: number;
  price: ItemPrice;
  modifierGroups: ModifierGroup[];
}

export interface ItemPrice {
  unitPrice: Price;
  totalPrice: Price;
  baseUnitPrice: Price;
  baseTotalPrice: Price;
}

export interface ModifierGroup {
  modifierGroupId: string;
  title: string;
  modifierOptions: ModifierOptionInOrder[];
}

export interface ModifierOptionInOrder {
  modifierOptionId: string;
  title: string;
  quantity: number;
  price: Price;
}

export enum OrderType {
  PICKUP = "pickup",
  DELIVERY = "delivery",
}

export interface Option {
  value: string;
  text: string;
}

export interface OrdersResponse {
  currentOrders: OrderSummary[];
  newOrders: OrderSummary[];
}

export interface OrderSummary {
  _id: string;
  displayId: string;
  orderPrice: Price;
  paymentInfo: {
    orderPrice: Price;
  };
  items: number;
  orderType: OrderType;
  createdAt: string;
}

export interface LoginData {
  email: string;
  password: string;
}

export interface ApiErrorData {
  code: string;
  message: string;
}

export interface ErrorResponse {
  status: number;
  data: ApiErrorData;
}

export const ERROR_CODES = {
  EXPIRED_TOKEN: "expired_token",
} as const;

export type ErrorCode = keyof typeof ERROR_CODES;

export interface LoginResponse extends Restaurant {
  accessToken: string;
}

export interface PaginationInfo {
  page: number;
  perPage: number;
  hasNext: boolean;
  count: number;
}

export interface Header {
  _id: string;
  displayName: string;
  isActive: boolean;
  displayOrder: number;
}

export interface Item {
  _id: string;
  displayName: string;
  haveStock: boolean;
  price: Price;
}

export interface ModifierOption {
  _id: string;
  displayName: string;
  haveStock: boolean;
  price: Price;
}
